<template>
  <div class="basic_wrap" >

<!--    <img class="logo" src="../images/logo/logo.png" alt="" @click="$router.push('/')" />-->
<!--    <img class="bg" src="../images/login/login_bg.png" alt="" @click="$router.push('/')" />-->

    <form class="form">
      <!-- <div class="cut_login">用户登录</div> -->
      <div class="item mt">
        <span class="icon">
          <img src="../images/login/phone_a.png" alt="" />
        </span>
        <input
          type="text"
          class="inp"
          v-model.trim="data.username"
          :placeholder="$t('请输入手机号码或邮箱')"
        />
      </div>
      <div class="item mt">
        <span class="icon"><img src="../images/login/pwd_a.png" alt="" /></span>
        <input
          :type="password"
          class="inp"
          v-model.trim="data.password"
          :placeholder="$t('请输入密码')"
        />
        <div
          style="margin-right: 10px"
          class="eye_bi"
          @click="showPwd"
          :class="password == 'text' ? 'eye' : ''"
        ></div>
      </div>
      <div class="item_reset_pwd">
        <van-checkbox v-model="checked" icon-size="14px">{{
          $t("记住我")
        }}</van-checkbox>
        <router-link
          class="reset_pwd"
          :to="{ path: '/forgetpwd', query: { phone: data.username } }"
        >
          {{ $t("忘记密码") }}
        </router-link>
      </div>

      <div
        type="submit"
        class="basic_btn sbtn"
        :class="data.username == '' || data.password == '' ? 'no_touch' : ''"
        @click="submit"
      >
        {{ $t("登录") }}
      </div>

      <p class="tips">
        {{$t("还没账号?")}}
        <span class="signup" @click="$router.push('/register')">{{
          $t("立即注册")
        }}</span>
      </p>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { CountDown, Checkbox,Dialog } from "vant";

Vue.use(Checkbox).use(Dialog);

export default {
  name: "login",
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      password: "password",
      show_kefu: false,
      msg_show: true,
      checked: true,
      data: {
        username: "",
        password: "",
      },
    };
  },

  created() {
    this.data.username = localStorage.getItem("login_username");
    this.data.password = localStorage.getItem("login_password");
    this.$parent.footer("user");
  },
  mounted() {
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
  },
  methods: {
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    submit() {
      if (!this.data.username) {
       
        this.$toast({
            //type:'fail',
            icon: require("../images/common/angry.png"),
            background: "#07c160",
            message:this.$t("请输入正确的手机号码"),
            duration:5000,
            className:"mytoast"
            
          });
        return;
      }

      if (!this.data.password) {
        
        this.$toast({
            // type:'fail',
            icon: require("../images/common/angry.png"),
            background: "#07c160",
            message:this.$t("密码为6-18位"),
            duration:5000,
          });
        return;
      }

      // var regex = /^[A-Za-z0-9]{1,20}$/;
      // if (!regex.test(this.data.username)) {
      //     this.$toast(this.$t('login.phoneError'));
      //     return;
      // }

      if (this.checked) {
        localStorage.setItem("login_username", this.data.username);
        localStorage.setItem("login_password", this.data.password);
      }

      if (!this.checked) {
        localStorage.removeItem("login_username");
        localStorage.removeItem("login_password");
      }
      this.data.username = this.data.username.replace(
        new RegExp("[+]", "gm"),
        ""
      );
      Fetch("/user/login", {
        account: this.data.username,
        password: this.data.password,
      }).then((res) => {
        console.log(res);
        //登录失败
        if (res.code == 0) {
          // Dialog.alert({
          //   message: res.msg,
          //   confirmButtonText: window.vm.$i18n.t("utils.confirm"),
          //   className:"mydio"
          // });
          this.$toast({
          
            // type:'fail',
            icon: require("../images/common/angry.png"),
            background: "#07c160",
            message: res.msg,
            duration:5000,
          });
        } else {
          if (res.data.userinfo.token) {
            localStorage.setItem("token", res.data.userinfo.token);
          }
          this.$toast({
            background: "#07c160",
            message: this.$t("登录成功"),
          });
          window.location.href = "/";
          // this.$router.replace({
          //   path: "/",
          // });
        }
      });
      // .then(() => {
      //   this.$router.replace({
      //     path: this.$router.history.current.query.redirect || "/",
      //   });
      // });
    },
  },
};
</script>

<style lang="less" scoped>

&::v-deep {
  .van-checkbox__icon--checked .van-icon {
    background: #FEEA02 !important;
    border:1px solid #FEEA02 !important;
    color: #0E4114!important;
  }
}
/deep/ .van-dialog{
    top: 37%!important;
    background: #000000!important;
}

.big_tit {
  position: absolute;
  height: 25px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
}
/deep/ .van-checkbox__label {
  color: white !important;
}

/deep/ .van-checkbox__icon--checked .van-icon {
  background: rgb(235, 193, 153);
  border-color: rgb(235, 193, 153);
  color: #383737;
  font-weight: 700;
  font-size: 12px;
}

.tips {
  height: 30px;
  line-height: 30px;
  color: #ffffff;
  margin-top: 8px;
  text-align: center;
  margin-top:20px;
  font-size: 15px;
}

.signup {
  font-weight: 700;
  font-size: 0.35rem;
  color: #FEEA02;
}

.login_bg {
  width: 100%;
  height: 220px;
  overflow: hidden;
  background: url("../images/login.png");
  background-position: center;
  background-size: 100% 100%;
  position: relative;

  .language {
    position: absolute;
    top: 4px;
    right: 0;
    height: 36px;

    img {
      height: 100%;
    }
  }
}

.lgbg {
  position: absolute;
  left: 5%;
  top: 20%;
  width: 90%;
  height: 80%;
}
.basic_wrap {
  // position: fixed;
  width: 100%;
  background: url("../images/login/login_bg_a.png") no-repeat;
  background-size: 100%;
  min-height: 100vh;
    // background: url('../images/vip/vip.png');
  //background: rgb(44, 102, 52);

}
.basic_wrap .form {
  // position: absolute;
  margin: 15px auto 0 auto;
  width: 92%;
  height: 40%;
  background: #0e4114bb;
  border-radius: 13px;
  margin-top:40vh;
  // border: 2px solid rgb(37, 50, 91);
  padding: 12px 12px 0 12px;
}
.basic_wrap .bg {
  width: 100%;
  height: 100px;
  margin-left: 8px;
  margin-top: 8px;
}
.cut_login {
  line-height: 25px;
  align-items: center;
  justify-content: center;
  font-size: 0.5rem;
  font-weight: 700;
  text-align: left;
  margin: 0 auto;
  color: white;

  a {
    width: 50%;
    padding-bottom: 10px;
    color: #ceced0;
    position: relative;

    .line {
      width: 100%;
      height: 1px;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #f2f2f2;
    }
  }

  a.cur {
    color: #f12211;

    .line {
      height: 2px;
      background-image: linear-gradient(to right, #f12211, #f18a11);
    }
  }
}

.mt {
  margin-top: 10px;
}

.item {
  height: 30px;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 8px;
  box-sizing: content-box;
  //border: 1px solid red;
  background: #287537bd;
  border-radius: 8px;

  .icon {
    width: 28px;
    height: 25px;

    img {
      display: block;
      margin: 0 auto;
      width: 17px;
      height: 20px;
    }
  }

  input {
    height: 25px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
    color: #FFFFFF;
    //font-weight: 700;
    font-size: 0.4rem;
  }
}

.item_reset_pwd {
  font-size: 14px;
  color: #3d96ff;
  text-align: right;
  margin-top: 10px;
  line-height: 20px;
  padding-left: 15px;
  padding-right: 15px;
}

.van-checkbox {
  margin-top: 20px;
}

.reset_pwd {
  //color: #3d96ff;
  color: #FEEA02;
  margin-top: -20px;
  display: block;
}

.basic_btn {
  margin: 45px auto 0 auto;
  color: #073F22 ;
  height: 40px;
  line-height: 40px;
  width: 95%;
  font-weight: 700;
  background: url("../images/login/submit.png") no-repeat;
  background-size: 100%;
  //background: linear-gradient(rgb(69, 253, 84), rgb(10, 166, 5));
}
</style>
